__turbopack_context__.v({
  "cardContent": "CreatorCollectionCard-module-scss-module__RRLtsG__cardContent",
  "creatorCollectionCard": "CreatorCollectionCard-module-scss-module__RRLtsG__creatorCollectionCard",
  "features": "CreatorCollectionCard-module-scss-module__RRLtsG__features",
  "noShadow": "CreatorCollectionCard-module-scss-module__RRLtsG__noShadow",
  "title": "CreatorCollectionCard-module-scss-module__RRLtsG__title",
});
